import { API_ENDPOINTS } from '../config/api.config';

/**
 * @param {string|number} userId
 * @param {string} yearMonth - "YYYY-MM"
 * @returns {Promise<Array<{id, user_id, date, full_day}>>}
 */
export const getAbsences = async (userId, yearMonth) => {
  const res = await fetch(`${API_ENDPOINTS.ABSENCES}?user_id=${userId}&year_month=${yearMonth}`);
  if (!res.ok) throw new Error('Failed to fetch absences');
  const json = await res.json();
  return json.data || [];
};

/**
 * All absence entries for a month (used by manager views).
 * @param {string} yearMonth - "YYYY-MM"
 * @returns {Promise<Array<{id, user_id, date, full_day}>>}
 */
export const getAllAbsencesForMonth = async (yearMonth) => {
  const res = await fetch(`${API_ENDPOINTS.ABSENCES}?year_month=${yearMonth}`);
  if (!res.ok) throw new Error('Failed to fetch absences');
  const json = await res.json();
  return json.data || [];
};

/**
 * Bulk insert absence days for a user (upserts on conflict).
 * @param {string|number} userId
 * @param {Array<{date: string, full_day: boolean}>} items
 * @returns {Promise<void>}
 */
export const addAbsences = async (userId, items) => {
  const res = await fetch(API_ENDPOINTS.ABSENCES, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: Number(userId), items }),
  });
  if (!res.ok) throw new Error('Failed to create absences');
};

/**
 * @param {string|number} id
 * @returns {Promise<void>}
 */
export const deleteAbsence = async (id) => {
  const res = await fetch(`${API_ENDPOINTS.ABSENCES}?id=${id}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error('Failed to delete absence');
};
